import * as React from "react";
const SvgFiRrLink = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-link_svg__a)">
      <path d="m13.845 17.267-3.262 3.262a5.028 5.028 0 0 1-7.11-7.109l3.261-3.265A1 1 0 1 0 5.32 8.741l-3.26 3.265A7.028 7.028 0 0 0 12 21.943l3.262-3.262a1 1 0 0 0-1.414-1.414zM21.945 2.061A6.98 6.98 0 0 0 16.975 0a6.98 6.98 0 0 0-4.968 2.057L8.74 5.32a1 1 0 1 0 1.415 1.415l3.265-3.262A5 5 0 0 1 16.973 2a5.028 5.028 0 0 1 3.553 8.583l-3.262 3.262a1 1 0 1 0 1.415 1.415L21.943 12a7.037 7.037 0 0 0 .003-9.939" />
      <path d="m14.293 8.293-6 6a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0-1.414-1.414" />
    </g>
    <defs>
      <clipPath id="fi-rr-link_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLink;
